import React from 'react';
import { useState } from "react";
import getUrl from "../../../../../Utility/GetUrl";
import { postData } from "../../../../../Utility/GlobalService";
import TextInput from "../../../Components/textInput";

const HashTag = ()=>{
    const [tag,setTag] = useState("");
    const [hashtagTitle,setHashtagTitle] = useState("");

    const postHasgtagTitle = (event)=>{
        event.preventDefault();
        const data = {
            title: hashtagTitle
        };
        postData(`${getUrl()}/hastag/title`,data);
        setHashtagTitle("");
    }
    const postHashtagTag = (event)=>{
        event.preventDefault();
        const data = {
            tag: tag
        };
        postData(`${getUrl()}/hastag/tag`,data);
        setTag("");
    }
    return (
        <div className="card">
            <div className="card-body mb-auto">
                <h5>About Page Hashtag</h5>
                <TextInput
                    title = "Title"
                    handleInputSubmit = {postHasgtagTitle}
                    setInputValue = {setHashtagTitle}
                    inputValue ={hashtagTitle}
                />
                <TextInput
                    title = "Hashtag"
                    handleInputSubmit = {postHashtagTag}
                    setInputValue = {setTag}
                    inputValue ={tag}
                />
            </div>
        </div>
    )
}
export default HashTag;